import styled from "@emotion/styled";

export const RoundedBlueAbsoluteContainer = styled.div`
  position: relative;
  z-index: 1;
  display: block;
  background: linear-gradient(to bottom, #03406c, #2C577D);
  padding-top: 25px;
  height: 70vh;
  min-height: 600px;
  width: 98%;
  border-radius: clamp(40px, 80px, 100px);
  margin: 15px auto;

  @media (max-width: 780px) {
    position: static;
    height: fit-content;
    width: 95%;
    margin: 10px auto;
    border-radius: clamp(20px, 40px, 60px);
  }
`;
